import React from "react";
import { ReactComponent as WarningIcon } from "@assets/icons/warning-solid-small.svg";
import { Callout } from "./callout";

export const Warning = ({ children }: React.PropsWithChildren<{}>) => (
  <Callout intent="caution" icon={WarningIcon}>
    {children}
  </Callout>
);
